import { createFeature, createSelector } from '@ngrx/store';
import { sourcesReducer } from '../reducers/sources.reducer';
import { AppState } from '../app.state';
import { iSourcesState } from '@app/Shared/interfaces/iSources';

export const sourcesFeature = createFeature({
    name: 'sources',
    reducer: sourcesReducer,
});

const selectSourcesState = (state: AppState) => state.sources;

export const { name: sourcesFeatureKey, reducer: sourcesFeatureReducer } = sourcesFeature;

// Selectors
export const selectSources = createSelector(selectSourcesState, (state: iSourcesState) => state.sources);

export const selectSelectedSource = createSelector(selectSourcesState, (state: iSourcesState) => state.selectedSource);

export const selectSourcesLoading = createSelector(selectSourcesState, (state: iSourcesState) => state.isLoading);

export const selectSourcesError = createSelector(selectSourcesState, (state: iSourcesState) => state.error);

export const sourcesFeatureSelectors = {
    ...sourcesFeature,
    selectSources,
    selectSelectedSource,
    selectSourcesLoading,
    selectSourcesError,
};

export const {
    selectSources: sourcesFeatureSelectSources,
    selectSelectedSource: sourcesFeatureSelectSelectedSource,
    selectSourcesLoading: sourcesFeatureSelectSourcesLoading,
    selectSourcesError: sourcesFeatureSelectSourcesError,
} = sourcesFeatureSelectors;

